import ExpandMoreIcon from "@mui/icons-material/Expand";
import { Grid, IconButton, Menu } from "@mui/material";
import { styled } from "@mui/material/styles";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { Breakpoint } from "../model/models";
import LanguageSelector from "./LanguageSelector";
import RightMenuToggle from "./RightMenuToggle";
import SupportAction from "./SupportAction";
const Grid_container = styled(Grid)(({ theme }) => ({
    height: "3.6rem",
    paddingRight: "1rem",
    marginTop: "4px",
}));
const Menu_buttonDialog = styled(Menu)(({ theme }) => ({
    width: "100%",
    zIndex: "1200 !important",
    "& .MuiMenu-paper": {
        paddingLeft: "5px",
    },
    "& .MuiMenu-list": {
        display: "inline-flex",
    },
}));
const IconButton_button = styled(IconButton)(({ theme }) => ({
    padding: "6px !important",
    "& svg": {
        fontSize: "2.4rem",
        color: "#001a37", //"var(--clr-primary)",
    },
    "&:hover svg": {
        color: "#009fe0", //"var(--clr-secondary)",
    },
    "&:disabled": {
        opacity: "0.5",
    },
}));
const ActionBar = observer((props) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const renderActions = () => {
        if (props.children) {
            return props.children;
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    const renderDefaultActions = () => {
        if (props.hideDefaultActions) {
            return React.createElement(React.Fragment, null);
        }
        else {
            return (React.createElement(React.Fragment, null,
                props.appModel.config["showLanguageMenu"] && (React.createElement(LanguageSelector, { appModel: props.appModel })),
                React.createElement(SupportAction, { appModel: props.appModel }),
                !props.appModel.custom.omitDshIntegration && (React.createElement(RightMenuToggle, { appModel: props.appModel }))));
        }
    };
    const renderContent = () => {
        if (props.appModel.appState.breakpoint == Breakpoint.sm) {
            return (React.createElement(Grid_container, { container: true, wrap: "nowrap" },
                React.createElement(IconButton_button, { onClick: (event) => {
                        setAnchorEl(event.currentTarget);
                        setMobileMenuOpen(true);
                    } },
                    React.createElement(ExpandMoreIcon, null)),
                React.createElement(Menu_buttonDialog, { id: "menu_rightActions", open: mobileMenuOpen, onClose: () => setMobileMenuOpen(false), anchorEl: anchorEl, transformOrigin: {
                        vertical: "top",
                        horizontal: "center",
                    } },
                    React.createElement("div", { style: { display: "inline-flex" } },
                        renderActions(),
                        renderDefaultActions()))));
        }
        else {
            return (React.createElement(Grid_container, { item: true, container: true, spacing: 1 },
                renderActions(),
                renderDefaultActions()));
        }
    };
    return (React.createElement(Grid, { item: true, style: { marginRight: "10px" } }, renderContent()));
});
export default ActionBar;
